import { Component, ViewEncapsulation, AfterViewInit, OnInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { filter, map, mergeMap } from 'rxjs/operators';
import { BASE_TITLE } from './config/system.config';
import { AuthInitializationService } from './services/auth/auth-initialization.service';

declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class AppComponent implements OnInit, AfterViewInit {

  isAuthPage = false;
  isDashboardPage = false;

  constructor(
    private titleService: Title,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authInitializationService: AuthInitializationService
  ) {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => {
          let route = this.activatedRoute.firstChild;
          while (route?.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        mergeMap(route => route?.data || [])
      )
      .subscribe(data => {
        const pageTitle = data['pageTitle'] || ''; // ✅ FIXED

        this.titleService.setTitle(
          pageTitle ? `${pageTitle} - ${BASE_TITLE}` : BASE_TITLE
        );

        const authRoutes = ['/login', '/register', '/reset', '/2fa'];
        this.isAuthPage = authRoutes.includes(this.router.url);

        this.isDashboardPage =
          this.router.url === '/dashboard' || this.router.url.startsWith('/dashboard/');
      });
  }

  ngOnInit(): void {
    // Initialize authentication state on app startup
    this.authInitializationService.initializeAuth().subscribe({
      next: (isAuthenticated) => {
        console.log('Authentication initialized:', isAuthenticated);
      },
      error: (error) => {
        console.error('Authentication initialization failed:', error);
      }
    });
  }

  ngAfterViewInit(): void {
  }

}
